




















































































































































































































































































import StatusDot from '@/components/StatusDot'
import VideoPlaceholder from '@/components/VideoPlaceholder'
import ChromaKeyModal from '@/components/ChromaKeyModal'
import Modal from '@/components/Modal'
import ComputerStats from '@/components/ComputerStats'
import VideoPlayer from '@/components/VideoPlayer'
import CasterDetails from '@/components/CasterDetails'
import PopOutMenu from '@/components/PopOutMenu'
import Interview from '@/components/Interview'
import { ErrorMessage, MenuItem } from '@/types'
import { VPopover } from 'v-tooltip'
import { getStreamStatus } from '@/helpers/statusHelper'
import { TeamMember } from '@/types/teams'
import { UserNetworkStats } from '@/types/networkstats'
import { UserProfile, UserNotification } from '@/types/users'
import { StreamStatusCode, SourceStream, StreamType, Stream, talkbackTargetType } from '@/types/streams'
import SubscribeNetworkstats from '@/mixins/SubscribeNetworkstats'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import Timeout = NodeJS.Timeout
import { KeyDict } from '@/types'
import { SystemStatus } from '@/types/ops'
import { CallTriage, Cast, CastSummary, InvitedCaster } from '@/types/casts'
import { TranscodingRegion } from '@/types/admin'
import { AssetType } from '@/types/assets'
import { Drag } from 'vue-drag-drop'
import SubscribeActiveCasts from '@/mixins/SubscribeActiveCasts'
import { Select, Option } from 'element-ui'
import { AudioMixType } from '@/types/casts'
import { pickBy } from 'lodash'
import mixins from 'vue-typed-mixins'
import { Feature } from '@/featureFlags/featureFlags'

export default mixins(SubscribeNetworkstats, SubscribeActiveCasts).extend({
  name: 'CasterStatus',
  props: {
    id: {
      type: String,
      required: true
    },
    caster: {
      type: Object as () => InvitedCaster,
      required: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    team: {
      type: Array as () => any[]
    },
    profile: {
      type: Object as () => UserProfile | undefined
    },
    currentUser: {
      type: Object as () => UserProfile | undefined,
      required: false
    },
    currentUserIsModerator: {
      type: Boolean,
      default: false
    },
    presence: {
      type: Object as () => KeyDict<string[]>
    },
    sourceStreams: {
      type: Object as () => KeyDict<SourceStream>
    },
    showRemove: {
      type: Boolean,
      default: false
    },
    showDisplayName: {
      type: Boolean,
      default: false
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    showMessage: {
      type: Boolean,
      default: false
    },
    showMessageSent: {
      type: Boolean,
      default: false
    },
    streamsManager: {
      type: Object
    },
    castingAs: {
      type: String,
      default: 'dontcare'
    },
    debug: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'summary' // options are summary or text
    },
    size: {
      type: String,
      default: 'full' // options are mini, ops, medium, full
    },
    isCurrentUser: {
      type: Boolean,
      default: false
    },
    stream: {
      type: Object as () => Stream,
      required: false
    },
    k360eventId: {
      type: Number,
      required: false
    },
    feedNames: {
      type: Array as () => string[],
      required: false,
    },
    invitedCasters: {
      type: Object as () => KeyDict<InvitedCaster>,
      required: false,
      default: (): KeyDict<InvitedCaster> => ({})
    }
  },
  watch: {
    errorStreaming (newVal: boolean) {
      this.$emit('statusChanged', !newVal)
    },
    networkScore () {
      if (!this.hasReportedLowBandwidth && this.isCasting && this.stats?.encoder !== undefined) {
        if (this.stats?.encoder?.video_bitrate < 150000) {
          this.$store.direct.dispatch.logs.addLog({
            message: `Caster ${this.id} has low video bandwidth ${this.stats.encoder.video_bitrate}`,
            level: 'info'
          })
          this.hasReportedLowBandwidth = true
        }
      }
    },
    bleeped () {
      this.bleepedStartTime = (new Date()).getTime()
      this.recalcBleepStyle()
    },
    'profile.udpEnabled' (newVal: boolean) {
      if (!newVal || !this.isCasting || this.isCurrentUser || !this.profile) return
      this.$emit('notifyCrew', {
        type: 'warning',
        message: `${ this.profile.first_name } ${ this.profile.last_name } is using a UDP connection. Low quality can be expected from this caster.`
      })
    },
    id: {
      handler (newVal: string) {
        this.networkStatsUserId = newVal
      },
      immediate: true
    },
    showInterviewModal (newVal: boolean) {
      if (newVal) {
        this.talkToCaster(true, talkbackTargetType.NONE)
      } else {
        if (this.talkbackTargetFallback === talkbackTargetType.CREW) {
          this.talkToCaster(true, talkbackTargetType.CREW)
        } else {
          this.talkToCaster(false, talkbackTargetType.NONE)
        }
      }
    }
  },
  data: () => ({
    showCasterInfo: false,
    showChroma: false,
    unsubscribeFB: null as Function | null,
    startTime: (new Date()).getTime(),
    hasReportedLowBandwidth: false,
    bleepStyle: {} as Partial<CSSStyleDeclaration>,
    recalcBleepStyleTimer: null as Timeout | null,
    previewVideoQuality: 'High',
    dragging: false,
    showPopover: false,
    bleepedStartTime: null as number | null,
    fpsThreshold: 20,
    showInviteOption: false,
    castToInvite: '',
    casterProfileToAssign: ''
  }),
  mounted () {
    this.recalcBleepStyle()
  },
  computed: {
    currentUserId (): string {
      return this.$store.direct.state.user.id
    },
    showQualifyButton (): boolean {
      if (!this.caster?.anonymous) return false
      const triages = [CallTriage.Unverified, CallTriage.InModeration]
      if (!triages.includes(this.caster?.triage)) return false
      return true
    },
    activeCasts (): KeyDict<CastSummary> {
      return this.$store.direct.state.events.activeCasts
    },
    otherActiveCasts (): KeyDict<CastSummary> {
      const casts: KeyDict<CastSummary> = {}
      for (const [castid, cast] of Object.entries(this.activeCasts)) {
        if (castid !== this.currentCast?.id) {
          casts[castid] = cast
        }
      }
      return casts
    },
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
    canSeeCasterInfo (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.Cast)
    },
    talkbackTargetFallback (): string {
      return this.$store.direct.state.streams.talkbackTargetFallback
    },
    talkBackAvailable (): boolean {
      const isCaster = !!this.$store.direct.getters.events.currentUserIsACaster
      return this.size === 'full' && this.isPresent && !isCaster && !this.isCurrentUser
    },
    bleepAvailable (): boolean {
      return !this.isSelfServe && this.isCasting && this.showRemove && this.caster && this.caster.triage === CallTriage.Accepted
    },
    currentCasterStreamAvailable (): boolean {
      const streamAvailable = !!this.$store.direct.state.events.currentCasterStream
      return streamAvailable
    },
    canDragCaster (): boolean {
      return this.draggable && this.isCasting && this.caster?.triage === CallTriage.Accepted
    },
    localCameraStream (): MediaStream | null {
      return this.$store.direct.state.events.localCameraStream
    },
    menuItems () : MenuItem[] {
      const items: MenuItem[] = []
      const isAnonymous = !!this.caster?.anonymous
      const isAccepted = this.caster?.triage === CallTriage.Accepted

      if (this.$can(AbilityAction.Edit, AbilitySubject.Cast) && this.showRemove) {
        items.push({ label: `Caster Info`, action: 'casterInfo', icon: 'info-circle' })
      }
      if (this.$can(AbilityAction.Edit, AbilitySubject.Members) && this.showRemove) {
        items.push({ label: `Edit Profile`, action: 'edit', icon: 'user-edit' })
      }
      if (this.$can(AbilityAction.Edit, AbilitySubject.Cast) && this.showRemove && isAccepted) {
        items.push({ label: 'Mute Speakers', action: 'silenceMonitorMix', icon: 'volume-mute' })
        items.push({ label: 'To Program Mix', action: 'switchToProgramMix', icon: 'volume-up' })
      }
      if (this.$can(AbilityAction.Edit, AbilitySubject.Cast) && this.isCasting && this.size === 'full') {
        items.push({ label: `Restart Stream`, action: 'restart', icon: 'sync-alt' })
      }
      if (this.$can(AbilityAction.Edit, AbilitySubject.Cast) && Object.values(this.activeCasts).length > 1 && this.size === 'full' && !isAnonymous) {
        items.push({ label: `Invite to cast`, action: 'invite', icon: 'envelope' })
      }
      if (this.stream?.id && this.$can(AbilityAction.Edit, AbilitySubject.Cast) && isAccepted) {
        const broadcastId = `${this.stream.id.split('_')[0]}broadcast`
        if (this.sourceStreams[broadcastId] === undefined) {
          items.push({ label: `Make Broadcast`, action: 'broadcast', icon: 'cloud-upload-alt' })
        }
      }
      if (this.showChromaButton && isAccepted) {
        items.push({ label: `Chromakey`, action: 'chroma', icon: 'eye-dropper' })
      }
      if (this.$can(AbilityAction.Edit, AbilitySubject.Cast) && this.showRemove) {
        items.push({ label: `Remove Caster`, action: 'remove', icon: 'trash' })
      }
      return items
    },
    assetDragData (): { asset: any } {
      const data = { asset: {} }
      if (this.casterSourceStream && !!this.stream) {
        // remove lowrate suffix before dragging
        let streamId = this.stream.id
        if (streamId && streamId.indexOf('_lowrate') > -1) {
          streamId = streamId.split('_lowrate')[0]
        }

        data.asset = {
          id: streamId,
          type: AssetType.Caster,
          name: (this.profile) ? this.profile.display_name : streamId
        }
      }
      return data
    },
    transcodingregions (): KeyDict<TranscodingRegion> {
      return this.$store.direct.state.admin.transcodingregions
    },
    networkRegion (): string {
      if (this.stats && this.stats.upload && this.stats.upload.region && this.stats.upload.region in this.transcodingregions)
        return this.transcodingregions[this.stats.upload.region].name
      else
        return "Unknown"
    },
    profileRegion (): string {
      if (this.profile !== undefined && this.profile.transcodingregion !== undefined && this.profile.transcodingregion in this.transcodingregions)
        return this.translateRegion(this.profile.transcodingregion)
      else
        return "Unknown"
    },
    regionMismatchMsg (): string {
      let status = ''
      if (this.profile && this.profile.transcodingregion && this.stats && this.stats.upload && this.stats.upload.region) {
        if (this.profile.transcodingregion !== this.stats.upload.region) {
          status = `Caster profile region is <b>${this.profileRegion}</b> and last network data is <b>${this.networkRegion}</b>. Caster should restart.`
        }
      }
      return status
    },
    showChromaButton (): boolean {
      let status = false
      if (this.size === 'medium' || this.size === 'full') {
        if (this.isCurrentUser) {
          status = (this.isCasting || this.errorStreaming)
        } else if (this.$can(AbilityAction.Edit, AbilitySubject.Cast)) {
          status = (this.isCasting || this.errorStreaming) && this.showRemove
        }
      }
      return status
    },
    bleeped (): number | undefined {
      if (this.$store.direct.state.events.currentCast.bleeped &&
          this.id in this.$store.direct.state.events.currentCast.bleeped)
        return this.$store.direct.state.events.currentCast.bleeped[this.id]
      return undefined
    },
    casterName (): string {
      let userName = ''
      const user = this.team.filter(user => user.user_id === this.id || user.id === this.id)
      if (user.length > 0) {
        userName = user[0].first_name + ' ' + user[0].last_name
      }
      return userName
    },
    statusCode (): StreamStatusCode {
      return getStreamStatus(this.casterSourceStream, this.stats, this.isPresent, 0)
    },
    userObject (): TeamMember | null {
      const user = this.team.filter(user => user.user_id === this.id || user.id === this.id)
      if (user.length > 0) {
        return user[0] as TeamMember
      }
      return null
    },
    networkScore (): number {
      let score: number = 0
      if (this.stats?.download !== undefined) {
        score = this.stats.download.score || 0
      }
      if (this.stats?.upload?.score && this.isCasting) {
        score = this.stats.upload?.score < score ? this.stats.upload?.score : score
      }
      if (this.errors.length > 0) {
        score = 0
      }
      return score
    },
    displayName (): string {
      let displayName = ''
      const user = this.team.filter(user => user.user_id === this.id || user.id === this.id)
      if (user.length > 0) {
        if (user[0].hasOwnProperty('display_name')) {
          displayName = user[0].display_name
        } else {
          displayName = user[0].first_name + ' ' + user[0].last_name
        }
      }
      return displayName
    },
    isPresent (): boolean {
      if (!this.presence) return false
      if (this.presence[this.id] !== undefined && this.presence[this.id].length > 0) return true
      return Object.values(this.sourceStreams).some(stream => stream.user_id === this.id)
    },
    casterSourceStreamKey (): string | null {
      let retkey : string | null = null
      let bestStartTime = 0
      for (const [key, stream] of Object.entries(this.sourceStreams)) {
        if (stream.user_id === this.id && stream.type === StreamType.Caster) {
          if (stream.start_time !== undefined && bestStartTime < stream.start_time) {
            retkey = key
            bestStartTime = stream.start_time
          }
        }
      }
      return retkey
    },
    casterSourceStream (): SourceStream {
      if (this.casterSourceStreamKey)
        return this.sourceStreams[this.casterSourceStreamKey]
      else
        return { type: StreamType.Caster } as SourceStream   // FIXME: lets not do this
    },
    isCasting (): boolean {
      let casting = false
      if (Object.keys(this.casterSourceStream).length && this.casterSourceStream.ngcvp_status === 'green') {
        casting = true
      }
      if (this.castingAs !== 'caster' && this.castingAs !== 'noncaster' && this.castingAs != 'dontcare') {
        casting = false
      }
      return casting
    },
    ngcvpStreamStatus (): SystemStatus | undefined {
      return Object.keys(this.casterSourceStream).length > 0 ? this.casterSourceStream.ngcvp_status : SystemStatus.NONE
    },
    ngCVPStatus (): boolean {
      let status = true
      if (this.casterSourceStream) {
        if (this.casterSourceStream.ngcvp_status === 'red' && this.casterSourceStream.start_time !== undefined) {
          if (this.casterSourceStream.start_time + 15 < (new Date()).getTime() / 1000 && this.startTime + 15 < (new Date()).getTime() / 1000) {
              status = false
            }
        }
      }
      return status
    },
    showFPSWarning (): boolean {
      let status = false
      if (this.isCasting) {
        if (this.stats?.encoder?.fps_out !== undefined && this.stats.encoder.fps_out < this.fpsThreshold) {
          // delay this check for once the stream is actually started up
          if (this.casterSourceStream.start_time !== undefined && (((new Date()).getTime() / 1000) - this.casterSourceStream.start_time) > 20000) {
            status = true
          }
        }
      }
      return status
    },
    errorStreaming (): boolean {
      if (!this.isPresent && !this.isCasting) {
        return false
      }
      let isError = false
      const uploadscore = this.stats?.upload?.score || 0
      if (this.isCasting && this.stats !== undefined && this.stats.upload !== undefined && this.stats.upload.score !== null) {
        if (uploadscore <= 2) {
          isError = true
        }
      }
      const downloadscore = this.stats?.download?.score || 0
      if (this.stats !== undefined && this.stats.download !== undefined && this.stats.download.score !== null) {
        if (downloadscore <= 2) {
          isError = true
        }
      }
      if (this.isCasting && this.stats?.encoder !== undefined) {
        if (this.stats.encoder.audio_bitrate === 0) {
          isError = true
        }
        if (this.stats.encoder.video_bitrate === 0) {
          isError = true
        }
        if (this.stats.encoder.cpu_usage > 80) {
          isError = true
        }
        // if (this.stats.encoder.fps_out < this.fpsThreshold) {
        //   isError = true
        // }
      }
      if (!this.ngCVPStatus) {
        isError = true
      }
      return isError
    },
    errors (): ErrorMessage[] {
      if (!this.isPresent) return []

      const errorList: any[] = []
      const networkMessage = 'Are you sure your home region is set correctly? Go back to the Dashboard -> Account Settings'
      const restartMessage = 'Something is wrong with your live stream, please stop casting and try again'
      const uploadscore = this.stats?.upload?.score || 0
      const downloadscore = this.stats?.download?.score || 0

      if (this.isCasting && this.stats !== undefined && this.stats.upload !== undefined && this.stats.upload.score !== null) {
        if (uploadscore <= 1) {
          errorList.push({ message: 'Poor Uplink', hint: networkMessage })
        }
      }
      if (this.stats !== undefined && this.stats.download !== undefined && this.stats.download.score !== null) {
        if (downloadscore <= 1) {
          errorList.push({ message: 'Poor Downlink', hint: networkMessage })
        }
      }
      if (this.isCasting && this.stats?.encoder !== undefined) {
        if (this.stats.encoder.audio_bitrate === 0) {
          errorList.push({ message: 'Video Only', hint: restartMessage })
        }
        if (this.stats.encoder.video_bitrate === 0 && this.castingAs === 'caster') {
          errorList.push({ message: 'Audio Only', hint: restartMessage })
        }
        if (this.stats.encoder.cpu_usage > 80) {
          errorList.push({ message: 'High CPU Usage' })
        }
        if (this.stats.encoder.fps_out < 10 && this.castingAs === 'caster') {
          errorList.push({ message: 'No Video' })
        }
        if (this.stats.encoder.fps_out > 10 && this.stats.encoder.fps_out < 16 && this.castingAs === 'caster') {
          errorList.push({ message: 'Low Framerate', hint: 'Your environment could be too dark, please check your lighting to increase the framerate' })
        }
        if (this.showFPSWarning && this.castingAs !== 'caster') {
          errorList.push({ message: 'Low Framerate' })
        }
        if (this.profile?.udpEnabled) {
          errorList.push({ message: 'UDP Connection', hint: 'Low quality can be expected from this caster' })
        }
        /* if (this.stats.encoder.video_bitrate < 150000) {
          errorList.push({ message: 'Low Video Bandwidth' })
        } */
      }
      if (!this.ngCVPStatus) {
        errorList.push({ message: 'Stream Issues', hint: restartMessage })
      }
      return errorList
    },
    tooltip (): string {
      let toolstring = ''
      if (this.errors.length > 0) {
        toolstring += '<center style="color: #cc4435;">' + this.errors[0].message + '</center>'
      }
      toolstring += '<table>'
      if (this.isCasting && this.stats?.upload !== undefined) {
        if (this.stats.upload.region && this.transcodingregions.hasOwnProperty(this.stats.upload.region)) {
          const name = this.transcodingregions[this.stats.upload.region].name
          toolstring += `<tr><td>Streaming Region</td><td>${name}</td></tr>`
        }
        toolstring += '<tr><td>Network Upload</td><td>' + this.stats.upload.score + '/5</td></tr>'
        toolstring += '<tr><td>Upload Speed</td><td>' + this.uploadSpeed + '</td></tr>'
        toolstring += '<tr><td>Upload Jitter</td><td>' + Math.round(this.stats.upload?.jitter || 0) + 'ms</td></tr>'
        toolstring += '<tr><td>Upload latency</td><td>' + Math.round(this.stats.upload?.latency || 0) + 'ms</td></tr>'
      }
      if (this.stats?.download !== undefined) {
        toolstring += '<tr><td>Network Download</td><td>' + this.stats.download.score + '/5</td></tr>'
        toolstring += '<tr><td>Download Speed</td><td>' + this.downloadSpeed + '</td></tr>'
        toolstring += '<tr><td>Download Jitter</td><td>' + Math.round(this.stats.download?.jitter || 0) + 'ms</td></tr>'
        toolstring += '<tr><td>Download latency</td><td>' + Math.round(this.stats.download?.latency || 0) + 'ms</td></tr>'
      }
      if (this.stats?.encoder !== undefined) {
        toolstring += '<tr><td>Encoder Resolution</td><td>' + this.stats.encoder.width + 'x' + this.stats.encoder.height + '</td></tr>'
        toolstring += '<tr><td>Encoder Bitrate</td><td>' + this.totalBitrate + 'kbps</td></tr>'
      }
      toolstring += '</table>'
      if (toolstring === '<table></table>') {
        toolstring = ''
      }

      // casl Ability type
      if (this.$can(AbilityAction.Do, AbilitySubject.Ops)) {
        toolstring += '<small><center>Click for more info</center></small>'
      }
      return toolstring
    },
    totalBitrate (): number {
      if (!this.stats || !this.stats.encoder) {
        return 0
      }
      const bitrate = this.stats.encoder.video_bitrate + this.stats.encoder.audio_bitrate
      return Math.floor(bitrate / 102.4) / 10
    },
    uploadSpeed (): string {
      if (!this.stats || !this.stats.upload) {
        return '0 Mbps'
      }
      const upload = this.stats.upload?.bandwidth || 0
      if (upload < 15) {
        return (Math.round(upload * 10) / 10) + 'Mbps'
      }
      return '> 15Mbps'
    },
    downloadSpeed (): string {
      if (!this.stats || !this.stats.download) {
        return '0 Mbps'
      }
      const download = this.stats.download?.bandwidth || 0
      if (download < 15) {
        return (Math.round(download * 10) / 10) + 'Mbps'
      }
      return '> 15Mbps'
    },
    stats (): UserNetworkStats | undefined {
      if (this.id === undefined) return undefined
      return this.$store.direct.getters.networkStats.userStats(this.id)
    },
    currentCast (): Cast | null {
      return this.$store.direct.state.events.currentCast
    },
    resolution (): string {
      if (this.currentCast === null || this.currentCast.quality === undefined) {
        return ''
      }
      const resStr = this.currentCast.quality.split('p')[0]
      return parseInt(resStr) + ''
    },
    fpsRounded (): number {
      if (this.currentCast === null) {
        return 0
      }
      const castFps = this.currentCast.framerate.replace('Hz', '')
      let fps = parseFloat(castFps)
      if (Math.ceil(fps) <= 30) {
        fps = 30
      } else {
        fps = 60
      }
      return fps
    },
    numInputs () : number {
      if (this.currentCast === null) {
        return 0
      }
      return Object.values(this.currentCast.source_streams).filter(stream => stream.type === 'broadcast').length
    },
    numIngests (): any {
      return this.$store.direct.getters.events.numIngests
    },
    canAddIngest (): boolean {
      return this.numInputs < this.maxAllowIngests
    },
    maxAllowIngests (): number {
      if (this.numIngests.hasOwnProperty(this.resolution)) {
        if (this.numIngests[this.resolution].hasOwnProperty(this.fpsRounded)) {
          return this.numIngests[this.resolution][this.fpsRounded]
        }
      }
      return 1
    },
    invitedCasterProfiles (): UserProfile[] {
      const ids = Object.keys(this.invitedCasters)
      const profiles = this.team.filter((profile) => ids.includes(profile.id) && !profile.anonymous)
      return profiles
    },
    isQualifyAllowed (): boolean {
      if (!this.currentUserIsModerator) return false
      if (this.caster?.triage !== CallTriage.Unverified) return false
      const castStreams = this.$store.direct.state.streams.castStreams
      const streams = pickBy(this.sourceStreams, (value) => value.user_id === this.id)
      const streamIds = Object.keys(streams)
      const id = `${ streamIds[0] }_lowrate`
      return !!castStreams[id]
    },
    isModeratedByAnother (): boolean {
      return this.caster?.triage === CallTriage.InModeration && this.caster?.moderator !== this.currentUserId
    },
    qualifyTooltip (): string {
      if (!this.currentUserIsModerator) return 'You need to connect as a moderator to qualify guests'
      if (this.isModeratedByAnother) return 'This guest is being moderated by someone else'
      if (!this.isQualifyAllowed) return 'This guest is not connected yet'
      return 'Qualify guest'
    },
    showInterviewModal (): boolean {
      return this.caster?.triage === CallTriage.InModeration && this.caster?.moderator === this.currentUserId
    }
  },
  methods: {
    leaveTalkback () {
      if (this.talkbackTargetFallback === talkbackTargetType.CREW) {
        this.talkToCaster(true, talkbackTargetType.CREW)
        return
      }

      this.talkToCaster(false, talkbackTargetType.NONE)
    },
    talkToCaster (active: boolean, target: string) {

      if (!this.localCameraStream) {
        console.log('Current user should connect to audio device (stream) first')
        return
      }

      // store talkback target
      const talkbackTarget = (active) ? target || this.id : talkbackTargetType.NONE
      this.$store.direct.dispatch.streams.setTalkbackTarget(talkbackTarget)

      // activate stream
      if (this.localCameraStream.getAudioTracks().length > 0) {
        this.localCameraStream.getAudioTracks()[0].enabled = active
      }
      console.log('talkToCaster', target)
    },
    recalcBleepStyle (): void {
      try {
        if (this.bleepedStartTime) {
            const timestamp = this.bleepedStartTime
            const dt = (new Date()).getTime() - timestamp - 1000
            if (dt < 0) {
              if (this.recalcBleepStyleTimer)
                clearInterval(this.recalcBleepStyleTimer)
              this.recalcBleepStyleTimer = setTimeout(() => { this.recalcBleepStyle () }, -dt + 100);
              this.bleepStyle = {
                backgroundColor: '#f24637'
              }
              return
            }
        }
      } catch (error) {
        console.error('CasterStatus recalcBleepStyle error ', error)
      }
      this.bleepStyle = {}
    },
    republishCaster (): void {
      this.$confirm('Are you sure you want this caster stream to restart?',
        'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(() => {
        this.$emit('requestCasterRepublish', this.id)
        this.$message({
          type: 'success',
          message: 'Restart caster stream succeeded'
        })
      }).catch(() => {
      })
    },
    requestCasterRepublish (casterId: string) : void { // this one comes from Interview
      this.$emit('requestCasterRepublish', casterId)
    },
    requestSilenceCasterMonitorMix (): void {
      this.$confirm('Are you sure you want to set the caster\'s audio settings to the monitor mix in muted state? ' +
                    'The caster won\'t hear anything as a result. However, his microphone settings remain unchanged.',
        'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(() => {
        if (this.currentCast === null) return
        this.$store.direct.dispatch.events.requestCasterCustomAudioMix({
          casterId: this.id,
          audioMixType: AudioMixType.Monitor,
          volumes: {
            default: 0
          },
          castId: this.currentCast.id
        })
      }).catch(() => {
      })
    },
    requestCasterSwitchToAudioMix (mixType: AudioMixType): void {
      this.$confirm('Are you sure you want to switch the caster\'s audio settings to the Program Mix? ' +
                    'This may impact volume levels and audio tracks the caster will hear.',
        'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(() => {
        if (this.currentCast === null) return
        this.$store.direct.dispatch.events.requestCasterSwitchToAudioMix({
          casterId: this.id,
          castId: this.currentCast.id,
          audioMixType: mixType
        })
      }).catch(() => {
      })
    },
    translateRegion (key): string {
      let region = 'Unknown'
      if (key in this.transcodingregions) {
        region = this.transcodingregions[key].name
      }
      return region
    },
    removeCaster (): void {
      this.$emit('removeCaster', this.id)
    },
    copyToBroadcast (): void {
      if (this.stream.id !== undefined) {
        try {
          if (this.canAddIngest) {
            this.$store.direct.dispatch.streams.copyCasterToBroadcast(this.stream.id)
            this.$message({ type: 'info', message: 'Caster added as Broadcast Stream'})
            this.$emit('casterCopied')
          } else {
            this.$message({ type: 'warning', message: 'Maximum number of broadcast inputs has been reached, caster not added!'})
          }
        } catch (error) {
          this.$message({ type: 'error', message: 'Could not add Caster as Broadcast Stream'})
          console.error('Could not copy caster -> Broadcast ', error)
        }
      }
    },
    menuClicked (item: string): void {
      switch (item) {
        case 'broadcast':
          this.copyToBroadcast()
          break
        case 'remove':
          this.removeCaster()
          break
        case 'chroma':
          this.showChroma = true
          break
        case 'edit':
          this.editCaster()
          break
        case 'restart':
          this.republishCaster()
          break
        case 'invite':
          this.castToInvite = Object.keys(this.otherActiveCasts)[0]
          this.showInviteOption = true
          break;
        case 'silenceMonitorMix':
          this.requestSilenceCasterMonitorMix()
          break
        case 'switchToProgramMix':
          this.requestCasterSwitchToAudioMix(AudioMixType.Program)
          break
        case 'casterInfo':
          this.showCasterInfo = this.canSeeCasterInfo
          break
      }
    },
    notifyCaster (): void {
      this.$emit('notifyCaster',  this.id)
    },
    undoNotifyCaster (): void {
      this.$emit('undoNotifyCaster',  this.id)
    },
    editCaster (): void {
      this.$emit('editProfile', this.id)
    },
    bleepCaster (): void {
      this.$store.direct.dispatch.events.bleepCaster(this.id)
    },
    handlePopover (status: boolean): void {
      if (this.size === 'mini' || this.size === 'ops') {
        this.showPopover = status
      } else {
        this.showPopover = false
      }
    },
    inviteCasterToOtherCast (): void {
      this.showInviteOption = false
      const notification = new UserNotification()
      notification.user_id = this.id
      const cast = this.activeCasts[this.castToInvite]
      if (cast === undefined) return
      notification.message = `You are invited to join the cast '${cast.name}'`
      notification.linkLabel = `Go to cast`
      const route = this.$router.resolve({ name: 'liveEvent', params: { id: this.castToInvite } })
      notification.link = route.href
      this.$store.direct.dispatch.events.inviteCasterToOtherCast({
        castId: this.castToInvite,
        casterId: this.id
      })
      this.$store.direct.dispatch.team.notifyTeamMember(notification)
        .then(() => {
          this.$message({
            type: 'success',
            message: `invite sent`
          })
        }).catch(error => {
          console.error('SingleCast.notifyCaster error ', error)
        })
    },
    async assignAnonymousCaster (casterProfileToAssign?: string): Promise<void> {
      const existingProfileId = casterProfileToAssign ?? this.casterProfileToAssign
      const anonymousProfile = this.profile
      const existingProfile = this.invitedCasterProfiles.find((profile) => profile.id === existingProfileId)
      const cast = this.$store.direct.state.events.currentCast

      if (!anonymousProfile || !existingProfile || !this.currentCast) {
        this.addLog('Unable to assign anonymous caster', 'error', { anonymousProfile, existingProfile })
        return
      }

      try {
        const invitedCasters = { ...this.invitedCasters }
        invitedCasters[anonymousProfile.id].triage = CallTriage.Assigned
        await this.$store.direct.dispatch.events.updateInvitedCasters({ castId: this.currentCast.id, invitedCasters })
        await this.$store.direct.dispatch.user.assignAnonymousCaster({
          anonymousProfile,
          existingProfile,
          castId: cast.id,
          updates: {
            profiles: true,
            streams: true,
            sessions: true
          }
        })
        this.$message({
          type: 'success',
          message: `Anonymous user has been assigned to ${ existingProfile.first_name } ${ existingProfile.last_name }`
        })
      } catch (error) {
        this.addLog('Unable to assign anonymous caster', 'error', { anonymousProfile, existingProfile, castId: cast.id, error })
        console.error(error)
      }
    },
    async openInterviewModal (): Promise<void> {
      if (this.profile?.id === undefined) return
      const payload = { userId: this.profile.id, triage: CallTriage.InModeration, moderatorId: this.currentUserId }
      await this.$store.direct.dispatch.events.setCasterTriage(payload)
    },
    closeInterviewModal (): void {
      if (this.profile?.id === undefined) return
      this.$store.direct.dispatch.events.setCasterTriage({ userId: this.profile.id, triage: CallTriage.Unverified })
    },
    addLog (message: string, level, data: any): void {
      this.$store.direct.dispatch.logs.addLog({
        message: message,
        data: data,
        level: level
      })
    }
  },
  components: {
    Modal,
    CasterDetails,
    ComputerStats,
    VideoPlayer,
    VideoPlaceholder,
    StatusDot,
    ChromaKeyModal,
    PopOutMenu,
    Drag,
    Interview,
    'popover': VPopover,
    'el-select': Select,
    'el-option': Option
  }
})
